import { render, staticRenderFns } from "./homeDashboardWorkCalendarStatistics.vue?vue&type=template&id=c671590e&scoped=true"
import script from "./homeDashboardWorkCalendarStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardWorkCalendarStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardWorkCalendarStatistics.vue?vue&type=style&index=0&id=c671590e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c671590e",
  null
  
)

export default component.exports